import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app-sidebar__brand" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "app-sidebar__brand-text"
}
const _hoisted_4 = {
  class: "app-sidebar__nav",
  "aria-label": "Navegación principal"
}
const _hoisted_5 = {
  key: 0,
  class: "app-sidebar__group"
}
const _hoisted_6 = {
  key: 0,
  class: "app-sidebar__group-title"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "app-sidebar__group"
}
const _hoisted_9 = ["disabled", "aria-expanded", "onClick"]
const _hoisted_10 = { class: "app-sidebar__subnav" }
const _hoisted_11 = { class: "app-sidebar__footer" }
const _hoisted_12 = ["aria-label", "title"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import logo from '@/assets/docbrain-logo-transparent.webp'
import type { NavigationGroup } from '@/config/navigation'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    collapsed: { type: Boolean },
    groups: {}
  },
  emits: ["toggle", "logout"],
  setup(__props: any) {

const props = __props


const route = useRoute()
const openGroups = ref(new Set<number>())

const routeMatches = (path: string) =>
  route.path === path || (path !== '/dashboard' && route.path.startsWith(`${path}/`))
const activeMenuRoute = computed(() =>
  props.groups
    .flatMap((group) => group.items)
    .filter((item) => routeMatches(item.route))
    .sort((first, second) => second.route.length - first.route.length)[0]?.route
)
const isActive = (path: string) => activeMenuRoute.value === path

const openActiveGroups = () => {
  props.groups.forEach((group, index) => {
    if (group.items.some((item) => isActive(item.route))) openGroups.value.add(index)
  })
}

const toggleGroup = (index: number) => {
  if (props.groups[index].items.length === 0) return
  const next = new Set(openGroups.value)
  next.has(index) ? next.delete(index) : next.add(index)
  openGroups.value = next
}

onMounted(openActiveGroups)
watch(() => route.path, openActiveGroups)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["app-sidebar", { 'app-sidebar--collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "app-sidebar__brand-link",
        "aria-label": "Ir al inicio"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _unref(logo),
            class: "app-sidebar__logo",
            alt: "DocBrain"
          }, null, 8, _hoisted_2),
          (!_ctx.collapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[2] || (_cache[2] = [
                _createElementVNode("strong", null, "DocBrain", -1),
                _createElementVNode("small", null, "Gestión inteligente", -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("nav", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, groupIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: group.title || 'principal'
        }, [
          (!group.title || _ctx.collapsed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (group.title && !_ctx.collapsed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(group.title), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.route,
                    class: "app-sidebar__link",
                    to: item.route,
                    title: _ctx.collapsed ? item.label : undefined,
                    "aria-label": _ctx.collapsed ? item.label : undefined,
                    "aria-current": isActive(item.route) ? 'page' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon),
                        "aria-hidden": "true"
                      }, null, 2),
                      (!_ctx.collapsed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.label), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "title", "aria-label", "aria-current"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "app-sidebar__group-toggle",
                  type: "button",
                  disabled: group.items.length === 0,
                  "aria-expanded": openGroups.value.has(groupIndex),
                  onClick: ($event: any) => (toggleGroup(groupIndex))
                }, [
                  (group.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(group.icon),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(group.title), 1),
                  (group.items.length > 0)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass(["fa-solid fa-chevron-down app-sidebar__group-chevron", { 'app-sidebar__group-chevron--open': openGroups.value.has(groupIndex) }]),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9),
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.route,
                      class: "app-sidebar__link app-sidebar__link--nested",
                      to: item.route,
                      "aria-current": isActive(item.route) ? 'page' : undefined
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(item.icon),
                          "aria-hidden": "true"
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "aria-current"]))
                  }), 128))
                ], 512), [
                  [_vShow, openGroups.value.has(groupIndex)]
                ])
              ]))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "app-sidebar__collapse",
        type: "button",
        "aria-label": _ctx.collapsed ? 'Expandir menú lateral' : 'Contraer menú lateral',
        title: _ctx.collapsed ? 'Expandir menú' : 'Contraer menú',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.collapsed ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left'),
          "aria-hidden": "true"
        }, null, 2),
        (!_ctx.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Contraer menú"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_12),
      _createElementVNode("button", {
        class: "app-sidebar__logout",
        type: "button",
        title: "Cerrar sesión",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logout')))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("i", {
          class: "fa-solid fa-right-from-bracket",
          "aria-hidden": "true"
        }, null, -1)),
        (!_ctx.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Cerrar sesión"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})